// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import PrivateRoute from './components/common/PrivateRoute';
import Layout from './components/common/Layout';

// Auth
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import VerifyEmail from './components/auth/VerifyEmail';
import AcceptInvitePage from './pages/AcceptInvitePage';

// Pages
import DashboardPage from './pages/DashboardPage';
import ProjectsPage from './pages/ProjectsPage';
import ExpensesPage from './pages/ExpensesPage';
import ReportsPage from './pages/ReportsPage';
import AIChatPage from './pages/AIChatPage';
import SettingsPage from './pages/SettingsPage';
import ProfilePage from './pages/ProfilePage';
import UpgradePage from './pages/UpgradePage';
import PlatformAdminPage from './pages/PlatformAdminPage';
import OrganizationStructurePage from './pages/OrganizationStructurePage';

import LandingPage from './pages/LandingPage';

// Components usati come pagine
import ProjectDetail from './components/projects/ProjectDetail';
import ProjectForm from './components/projects/ProjectForm';
import ExpenseForm from './components/expenses/ExpenseForm';

const wrap = (C) => <ErrorBoundary><C /></ErrorBoundary>;

const PLATFORM_ADMIN_EMAIL = 'goumouraphael57@gmail.com';

// Imposta il titolo della pagina
document.title = 'InfraPilot — Gestione Cantieri BTP';

function App() {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                    <Toaster position="top-right" toastOptions={{
                        duration: 4000,
                        style: { background: '#1e293b', color: '#f8fafc', borderRadius: '12px', fontSize: '14px', padding: '12px 16px' },
                        success: { duration: 3000 },
                        error: { duration: 5000 },
                    }} />
                    <Routes>
                        {/* ── Pubbliche ──────────────────────────────────────────── */}
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password/:token" element={<ResetPassword />} />
                        <Route path="/verify-email/:token" element={<VerifyEmail />} />
                        <Route path="/invite/:token" element={<AcceptInvitePage />} />

                        {/* ── Private ────────────────────────────────────────────── */}
                        <Route element={<PrivateRoute />}>
                            <Route element={<Layout />}>
                                <Route path="/dashboard" element={wrap(DashboardPage)} />
                                <Route path="/projects" element={wrap(ProjectsPage)} />
                                <Route path="/projects/new" element={wrap(ProjectForm)} />
                                <Route path="/projects/:id" element={wrap(ProjectDetail)} />
                                <Route path="/projects/:id/edit" element={wrap(ProjectForm)} />
                                <Route path="/expenses" element={wrap(ExpensesPage)} />
                                <Route path="/expenses/new" element={wrap(ExpenseForm)} />
                                <Route path="/expenses/:id/edit" element={wrap(ExpenseForm)} />
                                <Route path="/reports" element={wrap(ReportsPage)} />
                                <Route path="/upgrade" element={wrap(UpgradePage)} />
                                <Route path="/settings" element={wrap(SettingsPage)} />
                                <Route path="/profile" element={wrap(ProfilePage)} />

                                {/* ── Struttura organizzazione ──────────────────── */}
                                <Route path="/organization/structure" element={wrap(OrganizationStructurePage)} />

                                {/* ── Platform Admin — solo tu ──────────────────── */}
                                <Route path="/platform-admin" element={wrap(PlatformAdminPage)} />

                                {/* ── AI gated ──────────────────────────────────── */}
                                <Route element={<PrivateRoute requiredFeature="aiEnabled" />}>
                                    <Route path="/ai-chat" element={wrap(AIChatPage)} />
                                </Route>
                            </Route>
                        </Route>

                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </Router>
            </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;